import React, { useState } from 'react';
import './style.scss';
import StepsBar from './StepsBar';
import LimitForm from './Form';
import { withTranslation } from 'react-i18next';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const InternationalLimitForm = (props) => {
  const [activeStep, setActiveStep] = useState(1);
  const TOTAL_STEPS = 4;
  const steps = [
    { number: 1, title: props.t('TravelDetails'), descriptions: props.t('SteponeDescription') },
    { number: 2, title: props.t('Verification'), descriptions: props.t('StepTwoDescription') },
    { number: 3, title: props.t('Completion'), descriptions: props.t('StepThreeDescription') },
    { number: 4, title: props.t('Final'), descriptions: props.t('StepFourDescription') },
  ];

  const progress = ((activeStep - 1) / (TOTAL_STEPS - 1)) * 100;

  return (
    <div className="LimitContainer">
      <div className="limits_left_side">
        <StepsBar activeStep={activeStep} steps={steps} />
      </div>
      <div className="limits_right_side">
        <div className="form">
          <LimitForm
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            t={props.t}
            countriesEndpoint={props?.fields?.CountryEndpointURL.value}
            ExtraUserDetailsEndpoint={props?.fields?.ExtraUserDetailsEndpoint.value}
            IsMockExtraUserDetailsEndpoint={props?.fields?.IsMockExtraUserDetailsEndpoint.value}
            GenerateOTPEndpoint={props?.fields?.GenerateOTPEndpoint.value}
            IsMockGenerateOTPEndpoint={props?.fields?.IsMockGenerateOTPEndpoint.value}
            VerifyOTPEndpoint={props?.fields?.VerifyOTPEndpoint.value}
            IsMockVerifyOTPEndpoint={props?.fields?.IsMockVerifyOTPEndpoint.value}
            SubmitInternationalLimitEndpoint={props?.fields?.SubmitInternationalLimitEndpoint.value}
            limitationNumber={props?.fields?.limitationNumber?.value}
            limitationMessage={props?.fields?.limitationMessage?.value}
            timeoutErrorMessage={props?.fields?.timeoutErrorMessage?.value}
            verificationCodeExpiredErrorMessage={
              props?.fields?.verificationCodeExpiredErrorMessage?.value
            }
            timeout={props?.fields?.timeout?.value}
            otpVerificationCode={props?.fields?.otpVerificationCode?.value}
            otpDidNotReceiveText={props?.fields?.otpDidNotReceiveText?.value}
            otpSendNewCodeText={props?.fields?.otpSendNewCodeText?.value}
            GenerateOTPToken={props?.fields?.title?.value}
          />
        </div>
        <div className="MobileProgressBar">
          <div className="ProgressText">
            <span>{props.t('TotalProgress')}</span>
            <div>({Math.round(progress)}%)</div>
          </div>
          <div className="ProgressTrack">
            <div className="ProgressFill" style={{ width: `${progress}%` }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(withSitecoreContext()(InternationalLimitForm));
